import React, { useCallback, useEffect, useRef, useState } from 'react'

import { Box } from '../Box'
import { ModalsBackground, ModalsContainer } from './styles'

export const ModalsController: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null)

  const [backgroundVisible, setBackgroundVisible] = useState(false)

  const handleMutationChange = useCallback(() => {
    setBackgroundVisible(!!ref.current?.children.length)
  }, [])

  useEffect(() => {
    if (window.MutationObserver) {
      const observer = new window.MutationObserver(handleMutationChange)

      if (ref.current) {
        observer.observe(ref.current, { childList: true })
      }

      return () => {
        observer.disconnect()
      }
    }
  }, [handleMutationChange, ref])

  return (
    <Box
      position='fixed'
      top={0}
      bottom={0}
      left={0}
      right={0}
      zIndex={2001}
      style={{ pointerEvents: 'none' }}
    >
      <ModalsBackground $visible={backgroundVisible} />
      <ModalsContainer id='modals-container' ref={ref} />
    </Box>
  )
}
